import * as React from 'react'
import styled from 'styled-components'

import * as S from '../../../styles'

import { TextFieldWrapper } from './TextField'
import { FieldStatus } from './FieldStatus'

/* TODO: Maybe this component should be extracted ? it seems very specific to connect */

export type PasswordFieldProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> & {
  className?: string
  id?: string
  label?: React.ReactNode
  description?: string
  error?: string | boolean
  feedback?: {
    score: 'worst' | 'bad' | 'weak' | 'good' | 'strong'
    strength: string
    suggestions: string[]
  }
}

function PasswordFieldComponent({
  className,
  label,
  description,
  feedback,
  id = String(Math.random()),
  error,
  ...inputProps
}: PasswordFieldProps): React.ReactElement<PasswordFieldProps> {
  let status: 'default' | 'error' = 'default'
  if (Boolean(error) === true) {
    status = 'error'
  }

  return (
    <TextFieldWrapper className={className} htmlFor={id} label={label} description={description}>
      <S.input.Input {...inputProps} type="password" status={status} id={id} />
      {feedback && (
        <FieldStatus>
          <S.password.Indicator>
            <S.password.Strength score={feedback.score}>{feedback.strength}</S.password.Strength>{' '}
            {feedback.suggestions.join(' ')}
          </S.password.Indicator>
        </FieldStatus>
      )}
      {typeof error === 'string' && <FieldStatus error={error} />}
    </TextFieldWrapper>
  )
}

/** will forward any other props to the underlying `<input>` */
export const PasswordField = styled(PasswordFieldComponent)<PasswordFieldProps>``
PasswordField.displayName = 'PasswordField'
